import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ isAuthenticated, children }) {
    if (!isAuthenticated) {
        // Redirect to home if not authenticated
        return <Navigate to="/" replace />;
    }
    return children;
}

export default ProtectedRoute;
